import React from "react";

const VendorTableSkeleton = ({ rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="vendor-skeleton-row">
          <td>
            <div className="skeleton-text skeleton-name"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-email"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-phone"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-address"></div>
          </td>
          <td>
            <div className="action-buttons">
              <div className="skeleton-btn skeleton-action-btn"></div>
              <div className="skeleton-btn skeleton-action-btn"></div>
            </div>
          </td>
        </tr>
      ))}

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-btn {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 6px;
          height: 2rem;
          width: 2rem;
        }

        .skeleton-name {
          width: 120px;
          height: 1.2rem;
        }

        .skeleton-email {
          width: 180px;
          height: 1.2rem;
        }

        .skeleton-phone {
          width: 140px;
          height: 1.2rem;
        }

        .skeleton-address {
          width: 200px;
          height: 1.2rem;
        }

        .skeleton-action-btn {
          width: 32px;
          height: 32px;
          border-radius: 6px;
        }

        .vendor-skeleton-row {
          border-bottom: 1px solid #e9ecef;
        }

        .vendor-skeleton-row td {
          padding: 1rem 0.75rem;
          vertical-align: middle;
        }

        .action-buttons {
          display: flex;
          gap: 0.5rem;
          align-items: center;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .skeleton-name {
            width: 100px;
          }
          
          .skeleton-email {
            width: 140px;
          }
          
          .skeleton-phone {
            width: 120px;
          }
          
          .skeleton-address {
            width: 160px;
          }
        }

        @media (max-width: 576px) {
          .skeleton-name {
            width: 80px;
          }
          
          .skeleton-email {
            width: 120px;
          }
          
          .skeleton-phone {
            width: 100px;
          }
          
          .skeleton-address {
            width: 140px;
          }
        }
      `}</style>
    </>
  );
};

export default VendorTableSkeleton;
